import React, { Component } from "react";
import "./style.css";
class ErrorTip extends Component {
  render() {
    const { visible, errorInfo, handleCloseModal } = this.props;
    return (
      <div
        style={visible === true ? { display: "block" } : { display: "none" }}
        className="error_tip_box"
      >
        <div className="error_tip_modal">
          <img alt="" src={require("../../images/user/notice.png")}></img>
          <div className="error_tip_info">
            <p>{errorInfo}</p>
          </div>
          <div
            onClick={() => handleCloseModal()}
            className="error_tip_btn"
          >
            好 的
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorTip;



// WEBPACK FOOTER //
// ./src/components/ErrorTip/index.js